import { Box, Typography } from '@mui/material';
import { useCaseFieldData } from '../../hooks/useCaseField';
import type { FieldMode } from '../../hooks/useCaseField';
import type { MedNecCaseView } from '../../../../services/MedNecService/types/medNecTypes';

interface CaseDateDisplayProps {
  mode: FieldMode;
  label: string;
  getValue: (data: MedNecCaseView) => string | null | undefined;
}

function formatDate(iso: string | null | undefined): string {
  if (!iso) return '—';
  return new Date(iso).toLocaleString();
}

const CaseDateDisplay: React.FC<CaseDateDisplayProps> = ({ mode, label, getValue }) => {
  const data = useCaseFieldData(mode);

  return (
    <Box>
      <Typography variant="caption" color="text.secondary">{label}</Typography>
      <Typography variant="body2">{formatDate(getValue(data))}</Typography>
    </Box>
  );
};

export default CaseDateDisplay;
